import React, {useState, useContext, useEffect, useRef } from "react";
import { useTranslation } from 'react-i18next';
import { CloudFunctions } from "../../../../components/FirebaseAuth/firebase";
import { BreadcrumbContext } from '../../../../components/Breadcrumb';
import { Form, Input } from '../../../../components/Form';
import { Navigate } from 'react-router-dom';
import { Card, CardContent, Alert, Typography } from "@mui/material";
import DomainListField from "../../../../components/DomainListField";
import { localizeBackendError } from "../../../../libs/backendError";

const NewAccount = () => {
    const { t } = useTranslation();
    const mountedRef = useRef(true);

    const [accountName, setAccountName] = useState({
        hasError: false,
        error: null,
        value: null
    });

    const [domains, setDomains] = useState(["localhost"]);

    const [errorMessage, setErrorMessage] = useState(null);

    const [inSubmit, setInSubmit] = useState(false);

    const [redirect, setRedirect] = useState(null);
    const { setBreadcrumb } = useContext(BreadcrumbContext);

    useEffect(() => {
        setBreadcrumb([
            {
                to: "/",
                text: t('common.home'),
                active: false
            },
            {
                to: null,
                text: t('newProject.title'),
                active: true
            }
        ]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [setBreadcrumb, t]);

    useEffect(() => {
        return () => {
            mountedRef.current = false
        }
    },[]);


    return (
        <Card
            sx={{
                backgroundColor: (theme) => theme.custom.card,
                boxShadow: (theme) => theme.custom.cardShadow,
                border: (theme) => `1px solid ${theme.custom.border}`,
            }}
        >
            <CardContent>
        {redirect === null &&
        <>
                        <Typography variant="h5" sx={{ mb: 2 }}>{t('newProject.title')}</Typography>
                        <Typography sx={{ mb: 2, color: (theme) => theme.custom.muted }}>
                            {t('newProject.description')}
                        </Typography>
                        {errorMessage !== null &&
                            <Alert severity="error" onClose={() => setErrorMessage(null)} sx={{ mb: 2 }}>{errorMessage}</Alert>
                        }
                        <Form handleSubmit={e =>{
                            e.preventDefault();
                            setInSubmit(true);
                            setErrorMessage(null);
                            const createAccount = CloudFunctions.httpsCallable('createAccount');
                            createAccount({
                                accountName: accountName.value,
                                domains: domains
                            }).then(response => {
                                if (!mountedRef.current) return null
                                const accountId = response.data.accountId;
                                setRedirect('/account/'+accountId+'/billing/plan');
                            }).catch(err => {
                                if (!mountedRef.current) return null
                                setErrorMessage(localizeBackendError(err, t));
                                setInSubmit(false);
                            })
                        }}
                        disabled={accountName.hasError || accountName.value===null || inSubmit}
                        inSubmit={inSubmit}
                        submitBtnText={t('common.continue')}
                        enableDefaultButtons={true}>
                            <Input label={t('settings.websiteName')} type="text" name="account-name" maxLen={100} required={true} changeHandler={setAccountName} fullWidth variant="outlined" />

                            <DomainListField domains={domains} addDomain={newDoamin => {
                                setDomains(domains => [...domains, newDoamin])
                            }} removeDomain={index => {
                                const d = [...domains];
                                d.splice(index, 1);
                                setDomains(d);
                            }} />
                        </Form>

        </>
        }
        {redirect !== null &&
            <Navigate to={redirect} replace />
        }
            </CardContent>
        </Card>

    )
}

export default NewAccount;
